import '@/app/app.css';
import './registration.css';

import '@/app/app';
import '@/layouts/main/main';

window.addEventListener('DOMContentLoaded', () => {
	const registration = document.querySelector('.js-registration');
	const form = registration?.querySelector('.js-registration-form');
	const resultTemplate = registration?.querySelector('#registration-result');

	if (!registration || !form || !resultTemplate) return;

	const passwordInput = form.querySelector('#registration-password');
	const passwordConfirmInput = form.querySelector('#registration-password-confirm');
	const nextButtons = form.querySelectorAll('[data-step-next]');

	const setPasswordConfirmValidity = () => {
		if (!passwordInput || !passwordConfirmInput) return true;

		const isValid = passwordInput.value === passwordConfirmInput.value;
		passwordConfirmInput.setCustomValidity(isValid ? '' : 'Пароли не совпадают');

		return isValid;
	};

	const getSectionByStep = (step) => form.querySelector(`[data-step="${step}"]`);

	const setSectionStatus = (section, status) => {
		if (!section) return;
		section.dataset.status = status;
	};

	const getFieldLabel = (element) =>
		element.querySelector('.form-element__label span')?.textContent.trim() || '';

	const getFieldValue = (element) => {
		const field = element.querySelector('input, select, textarea');
		if (!field) return '';

		if (field.type === 'password' || field.name === 'password') {
			return field.value ? '********' : '';
		}

		if (field.type === 'radio' || field.type === 'checkbox') {
			return field.checked ? getFieldLabel(element) : '';
		}

		return field.value.trim();
	};

	const getSummaryItems = (section) => {
		const summaryItems = [];
		const fieldset = section.querySelector('[data-step-fields]');
		if (!fieldset) return summaryItems;

		const formElements = Array.from(
			fieldset.querySelectorAll('.js-form-element:not([data-summary-skip])'),
		).filter((element) => !element.closest('[data-summary-group]'));

		formElements.forEach((element) => {
			const label = getFieldLabel(element);
			const value = getFieldValue(element);

			if (!label || !value) return;

			summaryItems.push({ label, value });
		});

		const summaryGroups = fieldset.querySelectorAll('[data-summary-group]');
		summaryGroups.forEach((group) => {
			const checkedInput = group.querySelector('input:checked');
			if (!checkedInput) return;

			const option = checkedInput.closest('.js-form-element');
			const value = option?.querySelector('.form-checkbox__label')?.textContent.trim() || '';
			const label = group.dataset.summaryLabel || '';

			if (!label || !value) return;

			summaryItems.push({ label, value });
		});

		return summaryItems;
	};

	const renderStepResult = (section) => {
		const step = section.dataset.step;
		const resultContainer = section.querySelector(`[data-step-result="${step}"]`);
		if (!resultContainer) return;

		const summaryItems = getSummaryItems(section);
		const itemTemplate = resultTemplate.content.querySelector('[data-result-item]');
		const fragment = resultTemplate.content.cloneNode(true);
		const resultInner = fragment.querySelector('[data-result-inner]');
		const editButton = fragment.querySelector('[data-step-edit]');

		resultInner.querySelectorAll('[data-result-item]').forEach((item) => item.remove());

		summaryItems.forEach((item) => {
			const itemNode = itemTemplate.cloneNode(true);
			itemNode.querySelector('[data-result-label]').textContent = item.label;
			itemNode.querySelector('[data-result-text]').textContent = item.value;
			resultInner.insertBefore(itemNode, editButton);
		});

		editButton.dataset.stepEdit = step;
		resultContainer.replaceChildren(fragment);
	};

	const setStepComplete = (section, complete) => {
		section.dataset.status = complete ? 'complete' : 'active';
	};

	const validateSection = (section) => {
		if (!section) return false;

		if (section.dataset.step === '1') {
			setPasswordConfirmValidity();
		}

		const fieldset = section.querySelector('[data-step-fields]');
		if (!fieldset) return false;

		const fields = fieldset.querySelectorAll(':is(input, select, textarea)[data-look="true"]');
		let isValid = true;

		fields.forEach((field) => {
			const formElement = window.app.classInstance.get(field)?.formElement;
			if (!formElement?.validate({ noRender: false })) {
				isValid = false;
			}
		});

		return isValid;
	};

	passwordInput?.addEventListener('input', setPasswordConfirmValidity);
	passwordConfirmInput?.addEventListener('input', setPasswordConfirmValidity);

	nextButtons.forEach((button) => {
		button.addEventListener('click', () => {
			const currentSection = button.closest('[data-step]');
			const nextSection = getSectionByStep(button.dataset.stepNext);
			if (!currentSection || !nextSection) return;

			if (!validateSection(currentSection)) return;

			renderStepResult(currentSection);
			setStepComplete(currentSection, true);
			setSectionStatus(nextSection, 'active');
		});
	});

	form.addEventListener('click', (event) => {
		const editButton = event.target.closest('[data-step-edit]');
		if (!editButton) return;

		const targetSection = getSectionByStep(editButton.dataset.stepEdit);
		const currentActiveSection = form.querySelector('[data-step][data-status="active"]');

		if (!targetSection) return;

		// Спрятать текущий активный шаг, если он существует и это не тот, который редактируем
		if (currentActiveSection && currentActiveSection !== targetSection) {
			setSectionStatus(currentActiveSection, 'hidden');
		}

		// Вернуть форму для выбранного шага
		setStepComplete(targetSection, false);
	});
});

